import { fetchApi } from "../components/FetchApi";
import { wrapServiceCall } from "./ServiceUtils";

export const getCategories = () =>
  wrapServiceCall(() => fetchApi("/categories/list", { method: "GET" }));

export const getCategoryCounts = ({ categoryId, searchString, payload } = {}) =>
  wrapServiceCall(() => {
    let query = "";
    if (categoryId) {
      query += query ? `&categories=${categoryId}` : ``;
    }
    if (searchString) {
      query += query !== ""
        ? `&q=${encodeURIComponent(searchString)}`
        : `?q=${encodeURIComponent(searchString)}`;
    }
    return fetchApi(`/categories/counts/search${query}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload || {}),
    });
  });
